export const CAROUSEL_CROP_DIMS = {
  xs: {
    w: 540
  },
  s: {
    w: 768
  },
  m: {
    w: 1024
  },
  l: {
    w: 1280
  },
  xl: {
    w: 1348
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0ltYWdlR2FsbGVyeS9JbWFnZUdhbGxlcnkuY29uc3RhbnRzLnRzIl0sIm5hbWVzIjpbIkNBUk9VU0VMX0NST1BfRElNUyIsInhzIiwidyIsInMiLCJtIiwibCIsInhsIl0sIm1hcHBpbmdzIjoiQUFFQSxPQUFPLE1BQU1BLGtCQUE0QyxHQUFHO0FBQ3hEQyxFQUFBQSxFQUFFLEVBQUU7QUFBRUMsSUFBQUEsQ0FBQyxFQUFFO0FBQUwsR0FEb0Q7QUFFeERDLEVBQUFBLENBQUMsRUFBRTtBQUFFRCxJQUFBQSxDQUFDLEVBQUU7QUFBTCxHQUZxRDtBQUd4REUsRUFBQUEsQ0FBQyxFQUFFO0FBQUVGLElBQUFBLENBQUMsRUFBRTtBQUFMLEdBSHFEO0FBSXhERyxFQUFBQSxDQUFDLEVBQUU7QUFBRUgsSUFBQUEsQ0FBQyxFQUFFO0FBQUwsR0FKcUQ7QUFLeERJLEVBQUFBLEVBQUUsRUFBRTtBQUFFSixJQUFBQSxDQUFDLEVBQUU7QUFBTDtBQUxvRCxDQUFyRCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFJlc3BvbnNpdmVDcm9wRGltZW5zaW9ucyB9IGZyb20gJy4vSW1hZ2VHYWxsZXJ5LnR5cGVzJztcblxuZXhwb3J0IGNvbnN0IENBUk9VU0VMX0NST1BfRElNUzogUmVzcG9uc2l2ZUNyb3BEaW1lbnNpb25zID0ge1xuICAgIHhzOiB7IHc6IDU0MCB9LFxuICAgIHM6IHsgdzogNzY4IH0sXG4gICAgbTogeyB3OiAxMDI0IH0sXG4gICAgbDogeyB3OiAxMjgwIH0sXG4gICAgeGw6IHsgdzogMTM0OCB9LFxufTtcbiJdfQ==